function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import { Box } from "@chakra-ui/layout";
import { StylesProvider, useMultiStyleConfig } from "@chakra-ui/system";

var Control = props => {
  var {
    className,
    cx,
    children,
    innerRef,
    innerProps,
    isDisabled,
    isFocused,
    menuIsOpen,
    selectProps: {
      size,
      isInvalid,
      chakraStyles,
      focusBorderColor,
      errorBorderColor
    }
  } = props;
  var inputStyles = useMultiStyleConfig("Input", {
    focusBorderColor,
    errorBorderColor,
    size
  });
  var heights = {
    sm: 8,
    md: 10,
    lg: 12
  };

  var initialStyles = _objectSpread(_objectSpread({}, inputStyles.field), {}, {
    d: "flex",
    p: 0,
    overflow: "hidden",
    h: "auto",
    minH: heights[size]
  });

  var sx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.control ? chakraStyles.control(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(StylesProvider, {
    value: inputStyles
  }, /*#__PURE__*/React.createElement(Box, _extends({
    ref: innerRef,
    className: cx({
      control: true,
      "control--is-disabled": isDisabled,
      "control--is-focused": isFocused,
      "control--menu-is-open": menuIsOpen
    }, className),
    sx: sx
  }, innerProps, {
    "data-focus": isFocused ? true : undefined,
    "data-invalid": isInvalid ? true : undefined,
    "data-disabled": isDisabled ? true : undefined
  }), children));
};

export default Control;
//# sourceMappingURL=control.js.map